import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import {
  NgbModal,
  NgbTooltipModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HttpResponse } from '@angular/common/http';
import { UserManagementService } from '../../../Services/user-management.service';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-requestor',
  standalone: true,
  imports: [
    NgbTooltipModule,
    NgbPaginationModule,
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
  ],
  templateUrl: './requestor.component.html',
  styleUrls: ['./requestor.component.css'],
})
export class RequestorComponent implements OnInit {
  // Declaring necessary variables
  cityOptions: string[] = [];
  zoneOptions: string[] = [];
  userStatusOptions: string[] = [];
  statusOptions: string[] = [];
  filters: { [key: string]: string } = {};

  selectedUserType = 'all';
  selectedUser: any = null;
  selectedCity = 'all';
  selectedZone = 'all';
  selectedStatus = 'all';
  selectedFilterStatus = ''; // Status filter (empty means all)

  isChangeStatusPopupOpen = false;
  currentCityForStatusChange: any = null;
  requestorsData: any;
  originalTableData: any;
  cardData: any;

  userType: any[] = [];
  userApprovalstatus: any[] = [];
  cities: any[] = [];
  zones: any[] = [];

  // Open status change popup
  userId: any;
  isActive: any;
  userIdForDownload: any;
  downloadDocumentsModalRef: any;
  selectedUserTypeId: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private userService: UserManagementService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getRequestorUsers();
  }

  // Filter function to filter users based on selected filters
  filterGrid() {
    const userType = (
      document.getElementById('typeOfUser') as HTMLSelectElement
    ).value.trim();
    const selectedCity = (
      document.getElementById('selectCity') as HTMLSelectElement
    ).value.trim();
    const selectedZone = (
      document.getElementById('selectZone') as HTMLSelectElement
    ).value.trim();
    const selectedStatus =
      (
        document.getElementById('selectStatus') as HTMLSelectElement
      )?.value.trim() ?? 'all';

    console.log('Selected Filters:', {
      userType,
      selectedCity,
      selectedZone,
      selectedStatus,
    });

    this.requestorsData = this.originalTableData.filter((user: any) => {
      let match = true;

      // Convert userType from API to readable format
      const userTypeLabel = this.changeUserType(user.userType);

      // Filter by User Type
      if (
        userType !== 'all' &&
        userTypeLabel.toLowerCase() !== userType.toLowerCase()
      ) {
        match = false;
      }

      // Filter by City
      if (
        selectedCity !== 'all' &&
        user.cityName.trim().toLowerCase() !== selectedCity.toLowerCase()
      ) {
        match = false;
      }

      // Filter by Zone
      if (
        selectedZone !== 'all' &&
        user.zoneName.trim().toLowerCase() !== selectedZone.toLowerCase()
      ) {
        match = false;
      }

      // Filter by Status
      if (selectedStatus !== 'all') {
        const userStatus = this.getStatus(user.isActive);
        if (userStatus.toLowerCase() !== selectedStatus.toLowerCase()) {
          match = false;
        }
      }

      return match;
    });

    console.log('Filtered Users:', this.requestorsData);

    this.cdr.detectChanges(); // Force UI update
  }

  // Method to change user type based on the userType number
  changeUserType(userType: string): string {
    switch (userType) {
      case '1':
        return 'Individual Requestor';
      case '2':
        return 'Corporate Requestor';
      case '3':
        return 'Dumpster';
      case '4':
        return 'Dump Yard';
      default:
        return 'Unknown';
    }
  }

  // Open status change popup
  openChangeStatusPopup(content: any, user: any): void {
    this.userId = user.userId;
    this.isActive = user.isActive;
    this.currentCityForStatusChange = user;
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }

  // Change the status of the city
  changeCityStatus(modal: any): void {
    const toggledStatus =
      this.isActive === true || this.isActive === 'true' ? false : true;

    this.userService
      .postActiveInactiveUser(
        apiEndPoints.UserAccountStatusUpdate,
        this.userId,
        toggledStatus
      )
      .subscribe({
        next: (response: any) => {
          modal.close();
          this.currentCityForStatusChange.isActive = toggledStatus;
          this.toastr.success(
            `UserName "${
              this.currentCityForStatusChange.userName
            }" Status Changed to ${
              this.currentCityForStatusChange.isActive ? 'Active' : 'Inactive'
            }`,
            'Status Updated',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.getRequestorUsers();
        },
        error: (error: any) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // Handle filter visibility
  isUserTypeFilterVisible = false;
  isStatusFilterVisible = false;
  toggleStatusFilterDropdown(): void {
    this.isUserTypeFilterVisible = false;
    this.isStatusFilterVisible = !this.isStatusFilterVisible;
  }

  // Apply filter function
  applyFilter(type: any, filterBy: string): void {
    console.log(type); // Log the type being applied

    if (filterBy === 'isActive') {
      if (type === null) {
        this.requestorsData = this.originalTableData.filter(
          (user: any) => user.isActive === null
        );
      } else if (type === true) {
        this.requestorsData = this.originalTableData.filter(
          (user: any) => user.isActive === true
        );
      } else if (type === false) {
        this.requestorsData = this.originalTableData.filter(
          (user: any) => user.isActive === false
        );
      }
    } else if (filterBy === 'userType') {
      if (type === 'Unknown') {
        this.requestorsData = this.originalTableData.filter(
          (user: any) =>
            user.userType !== '1' &&
            user.userType !== '2' &&
            user.userType !== '3' &&
            user.userType !== '4'
        );
      } else {
        this.requestorsData = this.originalTableData.filter(
          (user: any) =>
            user.userType &&
            user.userType.toLowerCase().includes(type.toLowerCase())
        );
      }
    }

    console.log('Filtered Data:', this.requestorsData); // Log the filtered data
    this.isUserTypeFilterVisible = false;
    this.isStatusFilterVisible = false;
  }

  // Clear filter
  clearFilter() {
    this.getRequestorUsers();
  }

  // Search filter
  OnSearch(event: any) {
    const searchText = event.target.value.toLowerCase().trim();

    if (!this.originalTableData) {
      this.originalTableData = [...this.requestorsData];
    }

    if (searchText) {
      this.requestorsData = this.originalTableData.filter(
        (item: any) =>
          item.userName?.toLowerCase().includes(searchText) ||
          this.changeUserType(item.userType)
            ?.toLowerCase()
            .includes(searchText) ||
          this.getStatus(item.isActive)?.toLowerCase().includes(searchText) ||
          item.cityName?.toLowerCase().includes(searchText) ||
          item.zoneName?.toLowerCase().includes(searchText) ||
          item.crNumber?.toLowerCase().includes(searchText) ||
          item.vatNumber?.toLowerCase().includes(searchText) ||
          item.createdDate?.toLowerCase().includes(searchText)
      );
    } else {
      this.requestorsData = [...this.originalTableData];
    }
  }

  // Fetch user list from API
  getRequestorUsers() {
    this.userService.getUserList(apiEndPoints.allUsers, 6).subscribe({
      next: (response: any) => {
        this.requestorsData = response.body.details.userList;
        this.cardData = response.body.details;
        console.log(this.cardData);
        this.userType = [
          ...new Set(
            this.requestorsData.map((user: any) =>
              this.changeUserType(user.userType)
            )
          ),
        ];
        this.userApprovalstatus = [
          ...new Set(
            this.requestorsData.map((user: any) =>
              this.getStatus(user.isActive)
            )
          ),
        ];
        this.cities = [
          ...new Set(this.requestorsData.map((user: any) => user.cityName)),
        ];
        this.zones = [
          ...new Set(this.requestorsData.map((user: any) => user.zoneName)),
        ];
        this.originalTableData = [...this.requestorsData];
      },
      error: () => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // Get status label from status value
  getStatus(status: any): string {
    switch (status) {
      case true:
      case 'true':
      case 1:
        return 'Active';
      case false:
      case 'false':
      case 0:
        return 'Inactive';
      default:
        return 'Unknown';
    }
  }
  page = 1; // Current page
  pageSize = 5; // Number of items per page
  // Get paginated users based on current page and page size
  get pagedData() {
    const startIndex = (this.page - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return this.requestorsData?.slice(startIndex, endIndex);
  }

  // Handle page change
  onPageChange(page: number): void {
    this.page = page;
  }

  openDownloadDocumentsModal(user: any, modal: any) {
    console.log(user);
    // this.orderIdForDownloadInvoice = orderId;
    this.userIdForDownload = user.userId;
    this.selectedUserTypeId = user.userType;
    this.downloadDocumentsModalRef = this.modalService.open(modal);
  }

  downloadCrVatDocument(type: string) {
    this.downloadDocumentsModalRef.close();
    this.spinner.show();

    this.userService
      .crVatDownload(apiEndPoints.crVatDownload, this.userIdForDownload, type)
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          this.spinner.hide();

          // Extract the filename from Content-Disposition header
          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          let filename = this.extractFileName(contentDisposition);

          // Determine file extension based on 'type' or Content-Type
          const contentType = response.headers.get('Content-Type') || '';
          let extension = this.getFileExtension(contentType, type);

          // Fallback if filename is not found
          if (!filename) {
            filename = `user-${
              this.userIdForDownload
            }-${type.toLowerCase()}.${extension}`;
          }

          // Create a Blob URL
          const blob: Blob = response.body as Blob;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

          this.toastr.success('File downloaded successfully', 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        },
        error: (error: any) => {
          this.spinner.hide();
          console.error('Error:', error);
          this.toastr.error(
            'Unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            }
          );
        },
      });
  }

  private extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;

    // Match filename from Content-Disposition header
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']+)/
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  private getFileExtension(contentType: string, type: string): string {
    const mimeMap: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'xlsx',
      'application/octet-stream': type.toLowerCase() === 'cr' ? 'pdf' : 'jpg', // Fallback for CR or VAT type
    };

    // If contentType is not specified, rely on 'type' (CR or VAT)
    return mimeMap[contentType] || mimeMap['application/octet-stream'];
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.requestorsData);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'RequesterList.xlsx');
  }

  // ------------------------------- Print List or Download PDF ------------------------------- //

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Requester_List.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Requester List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Requestor Company Name' },
              { content: 'Mobile No' },
              { content: 'Requestor' },
              { content: 'City' },
              { content: 'Zone' },
              { content: 'Date Registered' },
              { content: 'CR Number' },
              { content: 'VAT Number' },
              { content: 'Status' },
            ],
          ];

          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.pagedData.forEach((user: any) => {
            const formattedDate = new Date(user.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
            let status = this.changeUserType(user.userType);
            let userStatus = this.getStatus(user.isActive);

            tableBody.push([
              user.userType === '1' ? user.userName : user.companyName,
              user.phNo,
              status,
              user.cityName,
              user.zoneName,
              formattedDate,
              user.userType === '2' ? user.crNumber : 'N/A',
              user.userType === '2' ? user.vatNumber : 'N/A',
              userStatus,
            ]);
          });

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
